// App.js
import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Guestbook from './components/Guestbook';
import GuestbookViewer from './components/GuestbookViewer';
import AdminWorkspaceList from './components/AdminWorkspaceList';
import AdminWorkspaceCreate from './components/AdminWorkspaceCreate.js';
import { Container } from '@mui/material';
import { Helmet } from 'react-helmet';
import AdminLogin from './components/AdminLogin';
import ProtectedRoute from './components/ProtectedRoute';
import MessageApproval from './components/MessageApproval';
 
import LandingPage from './components/LandingPage';
import PaymentPage from './components/PaymentPage';
 
import AdminWorkspaceEdit from "./components/AdminWorkspaceEdit";
import WorkspaceUrls from './components/WorkspaceUrls';
 
function App() {
    return (
        <>
            <Helmet>
                {/* 기본 메타 태그 */}
                <title>실시간 방명록​</title>
                <meta name="description" content="실시간으로 방명록을 남겨보세요"/>
                <meta name="keywords" content="방명록, 실시간 방명록, 메시지 남기기"/>
                {/* Open Graph 메타 태그 (카카오톡 링크 미리보기용) */}
                <meta property="og:type" content="website"/>
                <meta property="og:title" content="실시간 방명록​"/>
                <meta property="og:description" content="실시간으로 방명록을 남겨보세요"/>
                <meta property="og:image" content="https://realtime-guestbook.web.app/images/thumbnail.webp"/>
                <meta property="og:image:width" content="1200"/>
                <meta property="og:image:height" content="630"/>
                <meta property="og:url" content={`https://realtime-guestbook.web.app${window.location.pathname}`}/>
                <meta property="og:site_name" content="실시간 방명록"/>

                {/* Twitter 메타 태그 */}
                <meta name="twitter:card" content="summary_large_image"/>
                <meta name="twitter:title" content="실시간 방명록​"/>
                <meta name="twitter:description" content="실시간으로 방명록을 남겨보세요"/>
                <meta name="twitter:image" content="https://realtime-guestbook.web.app/images/thumbnail.webp"/>
            </Helmet>

            <Router>
                <Container
                    style={{
                        overflow: 'hidden',
                        padding: 0,
                        margin: 0,
                        width: '100%',
                        maxWidth: '100%',
                        textAlign: 'center',
                    }}
                >
                    <Routes>
                        <Route path="/" element={<LandingPage />} />
                        <Route path="/payment" element={<PaymentPage />} />
                        <Route path="/:workspaceId/write" element={<Guestbook />} />
                        <Route path="/:workspaceId" element={<GuestbookViewer />} />

                        <Route path="/:workspaceId/urls" element={<WorkspaceUrls />} />
                        <Route path="/:workspaceId/messages" element={<MessageApproval />} />
                        
                        {/* 관리자 라우트 */}
                        <Route path="/admin/login" element={<AdminLogin />} />
                        <Route path="/admin/workspaces" element={
                            <ProtectedRoute>
                                <AdminWorkspaceList />
                            </ProtectedRoute>
                        } />
                        <Route path="/admin/workspaces/create" element={
                            <ProtectedRoute>
                                <AdminWorkspaceCreate />
                            </ProtectedRoute>
                        } />
                        <Route path="/admin/workspaces/edit/:workspaceId" element={
                            <ProtectedRoute>
                                <AdminWorkspaceEdit />
                            </ProtectedRoute>
                        } />
                        {/* <Route path="/admin/workspaces/:workspaceId/messages" element={
                            <ProtectedRoute>
                                <MessageApproval />
                            </ProtectedRoute>
                        } /> */}
                         
                    </Routes>
                </Container>
            </Router>
        </>
    );
}

export default App;
